export default __webpack_public_path__ + "static/media/Ballroll_00273.95fd2c2d.png";